export default "__VITE_ASSET__QXEpPghO__"